import {UntypedFormControl, Validators} from '@angular/forms';
import {DateValidator} from '../../../create/properties/validator/date-validator';
import {ValidatorRegex} from '../../../create/properties/validator/validator-enum';

export interface UpdateSensorForm {
  instrumentType: UntypedFormControl;
  locationName: UntypedFormControl;
  startDate: UntypedFormControl;
  endDate: UntypedFormControl;
  xcoordinate: UntypedFormControl;
  ycoordinate: UntypedFormControl;
  zcoordinate: UntypedFormControl;
}

export const UpdateSensorFormConfig: UpdateSensorForm = {
  instrumentType: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(255),
  ]),
  locationName: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(40),
  ]),
  startDate: new UntypedFormControl(null, [
    Validators.required,
    DateValidator.validate(),
  ]),
  endDate: new UntypedFormControl(null, [
    DateValidator.validate(),
  ]),
  xcoordinate: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(10),
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  ycoordinate: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(10),
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  zcoordinate: new UntypedFormControl(null, [
    Validators.maxLength(10),
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};
